import { render, staticRenderFns } from "./TradeEffectData.vue?vue&type=template&id=7c7b51ef&scoped=true&"
import script from "./TradeEffectData.vue?vue&type=script&lang=js&"
export * from "./TradeEffectData.vue?vue&type=script&lang=js&"
import style0 from "./TradeEffectData.vue?vue&type=style&index=0&id=7c7b51ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b51ef",
  null
  
)

export default component.exports